import ActivitiesDataStore from '../../datastores/ActivitiesDataStore';

const data = {
  reservationEvent: {
    // eventTypes: [
    //   {
    //     name: 'Taller',
    //     idType: 1,
    //     subTypes: [{ idType: 1, name: 'Deportes', __typename: 'EventSubType' }]
    //   },
    //   { name: 'Conferencia', idType: 2, subTypes: [], __typename: 'EventType' },
    //   { name: 'Cine', idType: 3, subTypes: [], __typename: 'EventType' },
    //   { name: 'Concierto', idType: 4, subTypes: [], __typename: 'EventType' },
    //   {
    //     name: 'Activaciones',
    //     idType: 5,
    //     subTypes: [],
    //     __typename: 'EventType'
    //   },
    //   {
    //     name: 'Eventos Culturales y Artísticos',
    //     idType: 6,
    //     subTypes: [],
    //     __typename: 'EventType'
    //   },
    //   { name: 'Campeonatos', idType: 7, subTypes: [], __typename: 'EventType' },
    //   {
    //     name: 'Campañas de Salud',
    //     idType: 8,
    //     subTypes: [],
    //     __typename: 'EventType'
    //   },
    //   {
    //     idType: 8,
    //     name: 'Campañas de Salud',
    //     subTypes: [],
    //     __typename: 'EventType'
    //   }
    // ],
    subscriptions: [
      {
        idEvent: 89,
        modality: {
          description: 'Presencial',
          code: 'P'
        },
        code: '1656354457674311111',
        service: {
          serviceId: 107,
          name: 'Manualidades creativas Manualidades creativas Manualidades creativas'
        },
        date: '2022-09-12',
        startTime: '14:00',
        endTime: '16:00',
        hasCrossing: false,
        isRescheduled: true
      },
      // {
      //   idEvent: 36,
      //   modality: {
      //     description: 'Presencial',
      //     code: 'P'
      //   },
      //   code: '1656354457674',
      //   service: {
      //     serviceId: 107,
      //     name: 'Relaciones Internacionales'
      //   },
      //   date: '2022-09-12',
      //   startTime: '15:00',
      //   endTime: '16:00',
      //   hasCrossing: false,
      //   isRescheduled: false
      // },
      // {
      //   idEvent: 102,
      //   modality: {
      //     description: 'Presencial',
      //     code: 'P'
      //   },
      //   code: '165764166354822354',
      //   service: {
      //     serviceId: 107,
      //     name: 'Conferencia - consultas cp 4'
      //   },
      //   date: '2022-09-12',
      //   startTime: '14:30',
      //   endTime: '18:00',
      //   hasCrossing: false,
      //   sRescheduled: false
      // },
      {
        idEvent: 199,
        modality: {
          description: 'Presencial',
          code: 'P'
        },
        code: '1657641663578',
        service: {
          serviceId: 107,
          name: 'Conferencia - consultas cp 40'
        },
        date: '2022-12-20',
        startTime: '20:00',
        endTime: '21:00',
        hasCrossing: false,
        isRescheduled: true
      },
      {
        idEvent: 103,
        modality: {
          description: 'Presencial',
          code: 'P'
        },
        code: '1658247617652',
        service: {
          serviceId: 107,
          name: 'Conferencia - consultas cp 5'
        },
        date: '2022-08-05',
        startTime: '15:00',
        endTime: '21:00',
        hasCrossing: false
      },
      {
        idEvent: 1199,
        modality: {
          description: 'Remoto',
          code: 'R'
        },
        code: '1659452104971',
        service: {
          serviceId: 107,
          name: 'Taller - Evento Remoto Pruebas'
        },
        date: '2022-08-11',
        startTime: '21:30',
        endTime: '23:00',
        hasCrossing: false
      }
    ]
  }
};

export default class ActivitiesDataStoreMock implements ActivitiesDataStore {
  async getActivities() {
    return data.reservationEvent.subscriptions;
  }
}
